<template>
  <d-card>
    <d-card-row>
      <h1 class="title is-4">
        {{ $t('onboarding.start.email.title', {service: $registration.serviceTitle, host: $registration.host.name}) }}
      </h1>
      <p>
        {{ $t('onboarding.start.email.description') }}
      </p>
    </d-card-row>
    <d-card-row>
      <form
        v-loading="loading"
        @submit.prevent="submit()"
      >
        <b-field :label="$t('email')">
          <b-input
            v-model="email"
            type="email"
            name="email"
            required
            :autofocus="true"
          />
        </b-field>

        <button class="button is-primary">
          <span>{{ $t('next') }}</span>
          <div class="icon">
            <i class="mdi mdi-arrow-right" />
          </div>
        </button>
      </form>
    </d-card-row>
  </d-card>
</template>

<script>
export default {
  data () {
    return {
      email: null,
      loading: false
    };
  },
  methods: {
    submit () {
      this.loading = true;
      this.$http.get(route("api.registration.email", {
        email: this.email
      }))
        .then(response => {
          if (response.data.user) {
            this.$emit("login", this.email);
          } else {
            this.$emit("register", this.email);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
